<template>
  <div :class="$options.name">
    <v-card>
      <v-toolbar dark color="blue darken-3" flat>
        <router-link :to="{ name: 'object-form-create' }">
          <v-btn
            v-permission="['object-form-create']"
            color="primary"
            dark
            class="elevation-0"
          >
            Создать
          </v-btn>
        </router-link>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          label="Поиск"
          hide-details
          single-line
        />
      </v-toolbar>
      <v-data-table
        :items="list"
        :headers="headers"
        :loading="isLoading"
        :items-per-page="15"
        item-key="id"
        hide-default-footer
      >
        <template #item.actions="{ item }">
          <v-btn
            v-permission="['object-form-edit']"
            :to="{ name: 'object-form-item', params: { id: item.id } }"
            color="light"
            x-small
          >
            <v-icon left>edit</v-icon> Редактировать
          </v-btn>

          <v-btn
            v-permission="['object-form-delete']"
            color="error"
            class="ml-2"
            x-small
            @click="$dialog.show('object-form-remove-confirmation', { itemId: item.id })"
          >
            <v-icon left>delete</v-icon> Удалить
          </v-btn>
        </template>

        <template v-if="pagination" #footer>
          <v-pagination
            :length="pagination.lastPage"
            :total-visible="8"
            :value="pagination.currentPage"
            :disabled="pagination.lastPage === 1"
            color="blue darken-3"
            class="pb-4 pt-4"
            @input="onChangePage($event)"
          />
        </template>
      </v-data-table>
    </v-card>
    <remove-confirmation
      name="object-form-remove-confirmation"
      title="Вы действительно желаете удалить форму?"
      @confirmed="onObjectFormRemove"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';

export default {
  name: 'object-form-list',
  asyncData({ store }) {
    return store.dispatch('objectForms/getList');
  },
  components: {
    RemoveConfirmation,
  },
  data: () => ({
    isLoading: false,
    headers: [
      { value: 'name', text: 'Название формы', sortable: false },
      {
        value: 'actions',
        sortable: false,
        width: '30%',
        align: 'right',
      },
    ],
    search: '',
  }),
  computed: {
    ...mapState('objectForms', {
      originalList: 'list',
      originalPagination: 'pagination',
    }),
    ...mapState('objectForms/search', {
      searchList: 'list',
      searchPagination: 'pagination',
    }),
    list() {
      if (this.search && this.search.length && this.searchList) return this.searchList;
      return this.originalList;
    },
    pagination() {
      if (this.search && this.search.length && this.searchPagination) return this.searchPagination;
      return this.originalPagination;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    search: debounce(async function () {
      this.isLoading = true;
      await this.searchGetList({ query: this.search });
      this.isLoading = false;
    }, 750),
  },
  methods: {
    ...mapActions('objectForms', ['getNextPage', 'getList', 'remove']),
    ...mapActions('objectForms/search', {
      searchGetList: 'getList',
      searchNextPage: 'getNextPage',
    }),
    ...mapActions(['showNotify']),
    async onChangePage(page) {
      this.isLoading = true;
      if (this.search && this.search.length) {
        await this.searchNextPage({ page, query: this.search });
      } else {
        await this.getNextPage({ page });
      }
      this.isLoading = false;
    },

    async onObjectFormRemove(objectFormId) {
      this.isLoading = true;

      try {
        await this.remove(objectFormId);
        this.showNotify({ message: 'Форма успешно удалена' });
        await this.getList();
        await this.searchGetList({ query: this.search });
      } catch (e) {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
